/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fitty from 'fitty';

import * as AppPropTypes from '../../lib/PropTypes';

import { useResizeObserver } from '../../hooks/useObserver';

import styles from '../../../styles/partials/fit-text.module.scss';

const propTypes = {
    tag: PropTypes.string,
    minSize: PropTypes.number,
    maxSize: PropTypes.number,
    multiLine: PropTypes.bool,
    contentClassName: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node,
    cntRef: AppPropTypes.ref,
};

const defaultProps = {
    tag: 'div',
    minSize: 1,
    maxSize: Infinity,
    multiLine: false,
    contentClassName: null,
    className: null,
    children: null,
    cntRef: null,
};

const FitText = ({
    tag,
    minSize,
    maxSize,
    multiLine,
    contentClassName,
    className,
    children,
    cntRef,
}) => {
    const Tag = tag;
    const {
        ref,
        entry: { contentRect = null },
    } = useResizeObserver();
    const { width, height } = contentRect || {};

    useEffect(() => {
        fitty(ref.current, { minSize, maxSize, multiLine });
    }, [width, height, minSize, maxSize, multiLine]);

    return (
        <Tag
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            ref={cntRef}
        >
            <span className={styles.fit}>
                <span
                    className={classNames([
                        styles.content,
                        {
                            [contentClassName]: contentClassName !== null,
                        },
                    ])}
                    ref={ref}
                >
                    {children}
                </span>
            </span>
        </Tag>
    );
};

FitText.propTypes = propTypes;
FitText.defaultProps = defaultProps;

export default React.forwardRef((props, ref) => <FitText cntRef={ref} {...props} />);
